exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---o4P1h {\n  height: 100%;\n  min-width: 1100px; }\n  .component---o4P1h > div {\n    height: 100%; }\n  .component---o4P1h .report-container---3UqS6 {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---o4P1h",
	"report-container": "report-container---3UqS6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/participation/participation.scss
// module id = 1s1v
// module chunks = 1